//Generated File 
export const All = `All`;
export const DraftMode = `DraftMode`;
export const NewMode = `NewMode`;
export const UpdateMode = `UpdateMode`;
